import FieldGroup from "../../../components/base/forms/field-group";

export default class B2bCourseRegistrationFieldGroup extends FieldGroup {
    constructor(...props) {
        super(...props);

        this.$mailingFieldGroup = document.getElementById(`field-group-${this.options.formId}-mailing`);

        this.init();
    }

    init() {
        super.init();

        this.hideMailingFields();
        this.addEventListeners();
    }

    addEventListeners() {
        this.fields.exchangeService.subscribe('valueChange', ({ detail }) => {
            if (detail === 'mail') {
                this.showMailingFields();
            } else {
                this.hideMailingFields();
            }
        });
    }

    showMailingFields() {
        this.$mailingFieldGroup.classList.remove('-hidden');

        Object.keys(this.fields).forEach((fieldName) => {
            if (fieldName !== 'exchangeService') {
                this.fields[fieldName].show();
            }
        });

        this.forceFormValidation();
    }

    hideMailingFields() {
        this.$mailingFieldGroup.classList.add('-hidden');

        Object.keys(this.fields).forEach((fieldName) => {
            if (fieldName !== 'exchangeService') {
                this.fields[fieldName].hide();
            }
        });

        this.forceFormValidation();
    }
}